// 引入axios 实例
import request from '@/utils/request'
import qs from 'qs'

//保存反馈意见
export const saveFeedback = (data) => {
    return request({
        url: '/api/feedback/saveFeedback',
        method: 'post',
        data
    })
}
//获取列表
export const feedbackgetPageList = (params) => {
    return request({
        url: '/api/feedback/getPageList',
        method: 'post',
        params
    })
}

//根据阿里云附件地址获取转化后的图片
export function getFileByUrl(query) {
  return request({
    url: '/api/uploadFile/getFileByUrl',
    method: 'post',
    params: query
  })
}
//导出反馈列表
export function exportFeedback(query) {
  return request({
    url: '/api/feedback/exportFeedback',
    method: 'post',
    params: query,
    responseType: 'blob'
  })
}
//归档数据
export function deleteFeedback(query) {
  return request({
    url: '/api/feedback/deleteFeedback',
    method: 'post',
    params: query,
  })
}
//批量归档数据
export function feedbackdeleteFeedbackMore(query) {
  return request({
    url: '/api/feedback/deleteFeedbackMore',
    method: 'post',
    data: query,
  })
}
//反馈回复
export function feedbackreplyFeedback(query) {
  return request({
    url: '/api/feedback/replyFeedback',
    method: 'post',
    data: query,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

